import React from "react";
import { findDOMNode } from "react-dom";

// import PropTypes from "prop-types";
import { PropTypeShapes } from "../../types";
import { withDragAndDrop } from "./DragAndDropContext";

// HOC to automatically track the lifecycle of Drop Targets.
// Passes in the received callbacks
export function asDragSource(WrappedComponent, viewType, callbacks) {
  let returnComponent = null;

  //#!if readonly !== true
// 
// class DraggableComponent extends React.PureComponent {
// constructor(props) {
// super(props);
// this.state = {
// isDragging: false,
// dragIsFromSameSource: null
// };
// this.componentRef = React.createRef();
// this.setIsDragging = this.setIsDragging.bind(this);
// this.canDrag = this.canDrag.bind(this);
// this.getDragStartParams = this.getDragStartParams.bind(this);
// this.getPreviewElement = this.getPreviewElement.bind(this);
// }
// 
// componentDidMount() {
// this.registerDragSource(this.props);
// }
// 
// componentWillReceiveProps(nextProps) {
// this.registerDragSource(nextProps);
// }
// 
// componentWillUnmount() {
// this.props.dragAndDropRegistration.unregisterDragSource(this._dragSource.dragSourceId);
// }
// 
// registerDragSource(useProps) {
// const component = this.componentRef.current;
// const node = findDOMNode(component);
// const sourceParams = callbacks.getDragSourceParams(useProps);
// 
// this._dragSource = sourceParams;
// this._dragSource.component = component;
// this._dragSource.node = node;
// this._dragSource.setIsDragging = this.setIsDragging;
// this._dragSource.canDrag = this.canDrag;
// this._dragSource.getDragStartParams = this.getDragStartParams;
// this._dragSource.getPreviewElement = this.getPreviewElement;
// this._dragSource.dragSourceId = callbacks.getDragSourceId
// ? callbacks.getDragSourceId(useProps)
// : `${sourceParams.sourceView}-${sourceParams.itemId}`;
// 
// useProps.dragAndDropRegistration.registerDragSource(this._dragSource);
// }
// 
// canDrag(e) {
// if (callbacks.canDrag) {
// return callbacks.canDrag(this.props, this._dragSource, e);
// }
// return true;
// }
// 
// getDragStartParams() {
// if (callbacks.getDragStartParams) {
// return callbacks.getDragStartParams(this.props, this._dragSource);
// }
// return {};
// }
// 
// getPreviewElement() {
// if (callbacks.getPreviewElement) {
// return callbacks.getPreviewElement(this.props, this._dragSource);
// }
// return {};
// }
// 
// setIsDragging(isDragging, sourceView) {
// const dragIsFromSameSource = isDragging ? this._dragSource.sourceView === sourceView : null;
// if (this.state.isDragging !== isDragging || this.state.dragIsFromSameSource !== dragIsFromSameSource) {
// this.setState({
// isDragging,
// dragIsFromSameSource
// });
// }
// }
// 
// render() {
      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
// return (
// <WrappedComponent
// ref={this.componentRef}
// isDragging={this.state.isDragging}
// dragIsFromSameSource={this.state.dragIsFromSameSource}
// {...this.props}
// />
// );
// }
// }
// 
// DraggableComponent.propTypes = {
// dragAndDropRegistration: PropTypeShapes.dragAndDropRegistration.isRequired
// };
// 
// returnComponent = withDragAndDrop(DraggableComponent);
// 
  //#!else

  // eslint-disable-next-line react/display-name
  returnComponent = props => <WrappedComponent isDragging={false} {...props} />;

  //#!endif

  return returnComponent;
}
